export const CountiesConfig = [

    { id: "antrim", available: true, value: "Antrim" },
    { id: "armagh", available: true, value: "Armagh" },
    { id: "carlow", available: true, value: "Carlow" },
    { id: "cavan", available: true, value: "Cavan" },
    { id: "clare", available: true, value: "Clare" },
    { id: "cork", available: true, value: "Cork" },
    { id: "derry", available: true, value: "Derry" },
    { id: "donegal", available: true, value: "Donegal" },
    { id: "down", available: true, value: "Down" },
    { id: "dublin", available: true, value: "Dublin" },
    { id: "fermanagh", available: true, value: "Fermanagh" },
    { id: "galway", available: true, value: "Galway" },
    { id: "kerry", available: true, value: "Kerry" },
    { id: "kildare", available: true, value: "Kildare" },
    { id: "kilkenny", available: true, value: "Kilkenny" },
    { id: "laois", available: true, value: "Laois" },
    { id: "leitrim", available: true, value: "Leitrim" },
    { id: "limerick", available: true, value: "Limerick" },
    { id: "longford", available: true, value: "Longford" },
    { id: "louth", available: true, value: "Louth" },
    { id: "mayo", available: true, value: "Mayo" },
    { id: "meath", available: true, value: "Meath" },
    { id: "monaghan", available: true, value: "Monaghan" },
    { id: "offaly", available: true, value: "Offaly" },
    { id: "roscommon", available: true, value: "Roscommon" },
    { id: "sligo", available: true, value: "Sligo" },
    { id: "tipperary", available: true, value: "Tipperary" },
    { id: "tyrone", available: true, value: "Tyrone" },
    { id: "waterford", available: true, value: "Waterford" },
    { id: "westmeath", available: true, value: "Westmeath" },
    { id: "wexford", available: true, value: "Wexford" },
    { id: "wicklow", available: true, value: "Wicklow" }];